import React, { lazy, Suspense } from 'react'
import { colors } from '@fs/zion-ui'
import { css } from '@linaria/core'
import { useFeatureFlag } from '@fs/zion-flags'
import { useUser } from '@fs/zion-user'
import { useAdobeTarget } from '@fs/zion-adobe-target'
import Header2019WithData, { Header2019 } from './Header2019'
import AdminHeader, { AdminHeaderButton, AdminHeaderIconButton } from './AdminHeader'
import CFHeader from './CFHeader/CFHeader'
import LogoOnlyHeader from './LogoOnlyHeader'
import './locales'

const EXPERIENCES = {
  HEADER_NEW_LOGGED_OUT: 'NewHeaderLoggedOut',
  HEADER_OLD_LOGGED_OUT: 'OldHeaderLoggedOut',
}
export const homeHeaderActivityConfig = {
  location: 'home_header_unauthenticated',
  experienceIds: Object.values(EXPERIENCES),
}
const getHeaderAdobeConfig = (experienceId) => {
  switch (experienceId) {
    case EXPERIENCES.HEADER_NEW_LOGGED_OUT:
      return true
    case EXPERIENCES.HEADER_OLD_LOGGED_OUT:
      return false
    default:
      return false
  }
}

const UnauthenticatedHeader = lazy(() => import('./UnauthenticatedHeader'))

const PlaceholderHeaderCss = css`
  height: 60px;
  background: ${colors.gray00};
`

function PlaceholderHeader() {
  return <div className={PlaceholderHeaderCss} />
}

function HeaderABTest(props) {
  const { signedIn, userLoading } = useUser()
  const { data: adobeData, loading: adobeLoading, error: adobeError } = useAdobeTarget(homeHeaderActivityConfig)
  if (adobeLoading || userLoading) {
    return <PlaceholderHeader />
  }
  if (adobeError || signedIn || !getHeaderAdobeConfig(adobeData?.experienceId)) {
    return <Header2019WithData {...props} />
  }
  return (
    <Suspense fallback={<PlaceholderHeader />}>
      <UnauthenticatedHeader {...props} />
    </Suspense>
  )
}

function DefaultHeader(props) {
  const showUnauthenticatedHeader = useFeatureFlag('home_header_showUnauthenticatedHeader')?.isOn
  const useABTest = useFeatureFlag('home_header_showUnauthenticatedHeaderABTest')?.isOn
  if (showUnauthenticatedHeader) {
    if (useABTest) {
      return <HeaderABTest {...props} />
    }
    return (
      <Suspense fallback={<PlaceholderHeader />}>
        <UnauthenticatedHeader {...props} />
      </Suspense>
    )
  }
  return <Header2019WithData {...props} />
}

export default DefaultHeader
export {
  Header2019,
  AdminHeader,
  AdminHeaderIconButton,
  AdminHeaderButton,
  CFHeader,
  LogoOnlyHeader,
  UnauthenticatedHeader,
}
